(function () {
  class WinController {
    constructor() {
      this._batcher = undefined;
      this._winlineAnimator = undefined;
      this._symbolAnimator = undefined;
      this._active = false;
      this._skipped = false;

      this._lowWinSounds = ["winLow1", "winLow2", "winLow3"];
    }

    initialise(json) {
      this._batcher = resourceManager.getSharedPlugin(json.batcher_normal);

      this._symbolAnimator = json.symbolAnimator
        ? resourceManager.get(json.symbolAnimator)
        : undefined;
      this._winlineAnimator = json.winlineAnimator
        ? resourceManager.getSharedPlugin(json.winlineAnimator)
        : undefined;

      const symbols = resourceManager.getConfiguration().symbols;
      this._highWinIdToSoundMap = {
        [symbols["Stag"].ID]: "winStag",
        [symbols["Eagle"].ID]: "winEagle",
        [symbols["Bear"].ID]: "winBear",
        [symbols["Wolf"].ID]: "winWolf",
      };
      this._HIGHEST_LOW_SYMBOL_ID = symbols["Symbol_A"].ID;
      this._wolfIds = [
        symbols["Wolf"].ID,
        symbols["Symbol_Wild_1x2"].ID,
        symbols["Symbol_Wild_1x3"].ID,
        symbols["Symbol_Wild_1x4"].ID,
      ];
    }

    playWinSound(bestSymbolWinId) {
      let winSound = this._highWinIdToSoundMap[bestSymbolWinId];
      if (winSound == null && bestSymbolWinId <= this._HIGHEST_LOW_SYMBOL_ID) {
        const randIndex = Math.floor(Math.random() * this._lowWinSounds.length);
        winSound = this._lowWinSounds[randIndex];
      }
      soundManager.play(winSound);
    }

    playWinSounds(winData, celebrationThreshold) {
      let canCelebrate = winData.totalLineWinnings > celebrationThreshold;
      let sequenceData = this._batcher.batch(winData, celebrationThreshold)[0];
      if (canCelebrate) {
        let bestSymbolWin = 0;
        for (let i = 0; i < sequenceData.length; i++) {
          if (sequenceData[i].winId > bestSymbolWin) {
            bestSymbolWin = sequenceData[i].winId;
          }
        }
        if (
          sequenceData.flat().find((el) => this._wolfIds.includes(el.symbolId))
        ) {
          this.playWinSound(this._wolfIds[0]);
        }
        this.playWinSound(bestSymbolWin);
      }
    }

    startAnimations(
      winData,
      celebrationThreshold,
      slotMachine,
      completeCallback
    ) {
      const self = this;
      this._active = true;
      let canCelebrate = winData.totalLineWinnings > celebrationThreshold;
      let sequenceData = this._batcher.batch(winData, celebrationThreshold);
      this._skipped = false;

      self.playWinSounds(winData, celebrationThreshold);

      let currentSequence = 0;
      let playNextSequence = function (i) {
        let linesToPlay = [];

        for (let j = 0; j < sequenceData[i].length; ++j) {
          linesToPlay.push(sequenceData[i][j].winline);
        }

        let uniqueArray = linesToPlay.filter(function (item, pos) {
          return linesToPlay.indexOf(item) == pos;
        });

        let winlines = [];
        for (let j = 0; j < uniqueArray.length; ++j) {
          winlines.push(winData.winningLines[uniqueArray[j]]);
        }

        //removed oversize for any winanimations
        if (self._symbolAnimator) {
          let obj = sequenceData[i].find((e) => e.symbolId === 9);

          self._symbolAnimator.animateSymbols(
            sequenceData[i],
            slotMachine,
            canCelebrate,
            false,
            function () {
              ++currentSequence;
              if (currentSequence >= sequenceData.length || self._skipped) {
                self._active = false;
                completeCallback();
              } else {
                if (self._skipped) {
                  self._active = false;
                  completeCallback();
                } else {
                  playNextSequence(currentSequence);
                }
              }
            },
            undefined,
            undefined,
            undefined,
            true
          );
        }
      };
      playNextSequence(currentSequence);
    }

    isActive() {
      return this._active;
    }

    skipAnimations() {
      if (this.isActive()) {
        this._skipped = true;
        this._symbolAnimator.skip();
        if (this._winlineAnimator) this._winlineAnimator.skipAnimation();
      }
    }
  }

  let createWinController = function () {
    return new WinController();
  };

  resourceManager.registerController(
    "WinControllerAllAtOnce",
    createWinController
  );
})();
